import { render, staticRenderFns } from "./CiudadSalud.vue?vue&type=template&id=5e198e40"
import script from "./CiudadSalud.vue?vue&type=script&lang=js"
export * from "./CiudadSalud.vue?vue&type=script&lang=js"
import style0 from "./CiudadSalud.vue?vue&type=style&index=0&id=5e198e40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports